/**
 * Filling a template.
 *
 * A leaf module on purpose: it is a pure string operation with no React in it, and it
 * has to be reachable from a test file and from `lib/api.ts` without a bundler in
 * front of them. It lived in `i18n/index.tsx` first, which meant `node --test` could
 * not load it at all.
 */

export type Values = Readonly<Record<string, string | number>>;

/**
 * Fills `{name}` placeholders.
 *
 * A placeholder with no matching value is left exactly as written rather than
 * replaced with `undefined`. A visible `{email}` in a sentence is a mistake somebody
 * can see and report; `undefined` reads as a bug in the product, and it reads as one
 * on a payment page where the reader is already unsure.
 *
 * Leaving the braces in place is also what makes the failure catchable: a test can
 * assert that a rendered sentence has no `{...}` left in it, which it could not do if
 * the gap were silently filled with the string "undefined".
 */
export function format(template: string, values: Values = {}): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match,
  );
}